$(function () {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const $container = $(entry.target);
        const $num = $container.find('h2');

        const originalText = $num.text().trim();

        // Match numbers with optional commas (e.g. 1,200 or 25,000)
        const match = originalText.match(/(\d[\d,]*)/);
        if (!match) return;

        // Remove commas before converting to a number
        const targetCount = parseInt(match[0].replace(/,/g, ''), 10);

        // Split the text into: before number, number, after number
        const before = originalText.slice(0, match.index);
        const after = originalText.slice(match.index + match[0].length);

        $({ Counter: 0 }).animate(
          { Counter: targetCount },
          {
            duration: 3000,
            easing: 'swing',
            step: function () {
              const value = Math.ceil(this.Counter);

              // Add commas back while animating
              const formattedValue = value.toLocaleString();

              $num.text(before + formattedValue + after);
            },
            complete: function () {
              // Ensure the final value is exact
              $num.text(
                before +
                targetCount.toLocaleString() +
                after
              );
            }
          }
        );

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5
  });

  $('.animated-stat').each(function () {
    observer.observe(this);
  });
});